import { useState } from 'react';
import Social from './Social';
import Modal from './Modal';
import info from '../policy';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'en';

  useState(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsModalOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <footer>
      <span>© {new Date().getFullYear()} Incosys Trading SIA</span>
      <span
        className="privacy-policy-link"
        onClick={() => setIsModalOpen(true)}
      >
        {currentLang === 'en' ? 'Privacy Policy' : 'Privātuma politika'}
      </span>
      {/* <Social /> */}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={info[currentLang].title}
      >
        {info[currentLang].content}
      </Modal>
    </footer>
  );
};

export default Footer;
